import type {
  BasePortfolioSkillResource,
  PublicPortfolioSkillResource,
  StudentPortfolioSkillResource,
  TeacherPortfolioSkillResource,
} from "api/generated";
import type {
  BaseSkill,
  StudentSkill,
  TeacherSkill,
} from "portfolio/types/skill.types";

export const baseSkillFromDto = (
  resource: BasePortfolioSkillResource,
): BaseSkill => ({
  id: resource.id,
  name: resource.name,
  description: resource.description,
  categoryId: resource.category_id,
  colorCode: resource.color_code,
  educationLevels: resource.education_levels.filter(
    (level): level is string => level !== null,
  ),
});

export const studentSkillFromDto = (
  resource: StudentPortfolioSkillResource,
): StudentSkill => baseSkillFromDto(resource);

export const publicSkillFromDto = (
  resource: PublicPortfolioSkillResource,
): BaseSkill => ({
  id: resource.id,
  name: resource.name,
  description: resource.description,
  categoryId: resource.category_id,
  colorCode: null,
  educationLevels: resource.education_levels.filter(
    (level): level is string => level !== null,
  ),
});

export const teacherSkillFromDto = (
  resource: TeacherPortfolioSkillResource,
): TeacherSkill => ({
  ...baseSkillFromDto(resource),
  usedInActivitiesAmount: resource.used_in_activities_amount,
  meta: resource.meta,
});
